module.exports = __webpack_public_path__ + "media/images/icons/ic-like-fill-ac066d14ae9bd57cf7aa60c5b546307a.svg";